<template>
  <div class="bq-product-qxst">
    <SectionTitle :title="'产品简介'"></SectionTitle>
    <p class="title-desc">
      “患者360全息视图”是基于临床数据中心，医生可以通过简明、清晰地统一视图，对患者的整体概要和历次就诊进行查阅，为临床医护人员提供统一的数据整合视图。集成视图打破院区、科室、系统的数据界限，实现医院的信息资产收益最大化。
    </p>
    <div class="qxst-img">
      <img
        width="904"
        height="449"
        src="https://img.alicdn.com/tfs/TB1cUd4F4z1gK0jSZSgXXavwpXa-1808-898.png"
        alt=""
      />
    </div>
    <div class="qxst-descs">
      <InfoBox
        :col="3"
        :itemObj="item"
        v-for="item in list"
        :key="item.advTitles"
      ></InfoBox>
    </div>
    <SectionTitle :title="'数据与产品基础'"></SectionTitle>
    <div class="qxst-list">
      <div class="descs-item">
        <span
          >患者360产品，依托于标准化数据中心、数据交换平台、患者主索引、主数据管理等基础平台的建设。</span
        >
      </div>
      <div class="descs-item">
        <span
          >实现院内信息的互联互通，按照“以病人为中心”的原则进行数据的交换与共享，最终整合为患者360全息信息。</span
        >
      </div>
    </div>
    <SectionTitle :title="'产品优势'"></SectionTitle>
    <div class="qxst-adv">
      <InfoBox
        :col="3"
        :itemObj="item"
        v-for="item in datalist"
        :key="item.advTitles"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'qxst',
  data() {
    return {
      list: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1yMyjF4D1gK0jSZFyXXciOVXa-84-88.png',
          advTitles: '患者全息信息',
          advDesc:
            '整合患者在医院各个系统的临床就诊数据，体现了以患者为中心的临床数据可视化。保证临床数据精准、及时、直观。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1vBegF7Y2gK0jSZFgXXc5OFXa-96-96.png',
          advTitles: '多重信息维度',
          advDesc:
            '结合不同使用场景，将患者全息信息抽丝剥茧，整合成主次有序的视图。除时间轴、诊断轴模式外，独有专病专科模式，可自由配置信息，提高信息命中率。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB15CGjF7T2gK0jSZFkXXcIQFXa-94-86.png',
          advTitles: '辅助功能',
          advDesc:
            '完备的权限管理和数据安全保障，根据医院个性化需求做到高度可配置的同时，保护好患者隐私。',
        },
      ],
      datalist: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1N05gF.T1gK0jSZFhXXaAtVXa-96-96.png',
          advTitles: '信息的层次化展示',
          advDesc:
            '将以患者为中心的数据，按照时间轴、诊断轴等方式展开，信息分主次、有重点。专病专科模板配置则将信息整合的权限赋予医生，让每个医生都可以有自己最顺手、最常用、最习惯的360全息视图模板。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1rPWeF4n1gK0jSZKPXXXvUXXa-96-96.png',
          advTitles: '智能推荐和自动记忆',
          advDesc:
            '利用人工智能大数据技术，根据自动记忆的医生的使用习惯，智能推荐医生感兴趣的内容，在跳转相应信息页面时自动展开。能够做到使用越频繁，推荐越精确。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1.75dFVT7gK0jSZFpXXaTkpXa-96-96.png',
          advTitles: '科研功能拓展',
          advDesc:
            '基于大数据的相似病历查找、全文检索、标签体系等，帮助医生精准定位临床病例，辅助医生更好地进行科研探索。',
        },
      ],
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
.bq-product-qxst {
  width: 1200px;
  margin: 0 auto;
  .title-desc {
    color: #333;
    font-size: 18px;
  }

  .qxst-img {
    margin: 60px 0;
    text-align: center;
  }

  .qxst-descs {
    display: flex;
    justify-content: space-between;
    margin-bottom: 90px;
    .bq-infobox {
      width: 352px !important;
    }
  }

  .qxst-list {
    display: flex;
    justify-content: space-between;
    .descs-item {
      width: 564px;
      padding: 20px;
      color: #fff;
      background-color: #014dba;
      border-radius: 4px;

      h3 {
        font-size: 20px;
      }

      span {
        font-size: 18px;
        font-weight: 300;
      }

      &:first-child {
        background-color: #003a8c;
      }

      &:last-child {
        background-color: #045bd8;
      }
    }
  }

  .qxst-adv {
    display: flex;
    justify-content: space-between;
    margin-bottom: 60px;
    .bq-infobox {
      width: 352px !important;
    }
  }

  /deep/ .bq-infobox {
    p {
      font-size: 18px;
    }
  }
}
</style>
